import styled, { css } from 'styled-components';
import { SCREEN_SIZE } from '../grid/constants/sizes';
import { Yellow } from '../../colors';
const flipStyles = css `
    transform: rotateY(180deg);
`;
const revertFlipStyles = css `
    transform: rotateY(0deg);
`;
export const Front = styled.div `
    height: 100%;
    width: 100%;
    position: absolute;
    border-radius: 10px;
    background-size: contain;
    backface-visibility: hidden;
    background-position: center;
    background-repeat: no-repeat;
    background-image: url(${(props) => props.image});
    -webkit-backface-visibility: hidden;
    background-color: ${Yellow.skin};

    & div, input, label, span {
        -webkit-backface-visibility: hidden;
        backface-visibility: hidden;
    }
`;
export const Back = styled.div `
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    position: absolute;
    height: 100%;
    width: 100%;
    border-radius: 10px;

    background-image:url(${(props) => props.image});
    background-color: ${Yellow.skin};
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
`;
export const CardContainer = styled.div `
    height: 190px;
    width: 320px;
    margin: 0;
    position: relative;
    border-radius: 10px;
    perspective: 1000px;
    transition: transform 1s;
    transform-style: preserve-3d;

    @supports (backface-visibility: hidden) {
        ${(props) => props.flip ? flipStyles : revertFlipStyles};

        ${Back} {
            transform: rotateY(180deg);
        }
    }

    @supports not (backface-visibility: hidden) {
        ${Front} {
            ${(props) => props.flip ? 'visibility: hidden' : 'visibility: visible'};
        }

        ${Back} {
            ${(props) => !props.flip ? 'visibility: hidden' : 'visibility: visible'};
        }
    }

    @media (min-width: ${SCREEN_SIZE.DESKTOP.min}) {
        height: 210px;
        width: 355px;
    }

    @media (max-width: 340px) and (min-width: 300px){
        width: 280px;
        height: 170px;
    }
`;
export const FrontContent = styled.div `
    margin: 60px 40px 15px 25px;
    @media (min-width: ${SCREEN_SIZE.DESKTOP.min}) {
        margin: 76px 30px 15px 25px;
    }
`;
export const BackContent = styled.div `
    margin: 70px 0 0 114px;
    width: 180px;

    @media (min-width: ${SCREEN_SIZE.DESKTOP.min}) {
        margin: 82px 0 0 127px;
        width: 190px;
    }

    @media (max-width: 340px) and (min-width: 300px){
        margin: 56px 0 0 100px;
        width: 167px;
    }
`;
//# sourceMappingURL=IdCard.Styles.js.map